import { render } from "./driving_licence_list.vue?vue&type=template&id=fc6d9f82&scoped=true&ts=true"
import script from "./driving_licence_list.vue?vue&type=script&lang=ts"
export * from "./driving_licence_list.vue?vue&type=script&lang=ts"

import "./driving_licence_list.vue?vue&type=style&index=0&id=fc6d9f82&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6d9f82"]])

export default __exports__